module.exports = __webpack_public_path__ + "static/img/bianp.9d4d69c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/bianp.png
// module id = +7z4
// module chunks = 1